import BlockedUserModal from '@zg-rentals/blocked-user-modal';
import { useSelector } from 'react-redux';

import type { UserInitStateInterface } from '@common/types';

export default function BlockedUserModalGate() {
  const user = useSelector((state: { user: UserInitStateInterface }) => state.user);

  if (user?.restrictions?.isAllowed !== false) {
    return null;
  }

  return <BlockedUserModal user={user} />;
}
